module.exports = __webpack_public_path__ + "static/TriAzurIcon-40ace683b384504022a625add24052b7.png";